function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Checkbox as ChakraCheckbox } from '@chakra-ui/checkbox';
import { forwardRef } from '@chakra-ui/system';
import React from 'react';
import { CheckboxIcon } from './checkbox-icon';
export var Checkbox = forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(ChakraCheckbox, _extends({}, props, {
    icon: props.icon || /*#__PURE__*/React.createElement(CheckboxIcon, {
      type: props.type
    }),
    ref: ref
  }));
});
//# sourceMappingURL=checkbox.js.map